import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VDataTable, {
    attrs: {
      headers: _vm.tabela.headers,
      items: _vm.perfis,
      search: _vm.tabela.opcoes.pesquisa,
      "custom-filter": _vm.customFilter,
      "sort-by": _vm.tabela.opcoes.ordenarPor,
      "sort-desc": _vm.tabela.opcoes.decrescente,
      "item-key": "id",
      "show-expand": "",
      "single-expand": "",
    },
    scopedSlots: _vm._u(
      [
        {
          key: "top",
          fn: function () {
            return [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-sort", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(VSpacer),
                  _c(
                    VCol,
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("app-search", {
                        model: {
                          value: _vm.tabela.opcoes,
                          callback: function ($$v) {
                            _vm.$set(_vm.tabela, "opcoes", $$v)
                          },
                          expression: "tabela.opcoes",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: `item.numero`,
          fn: function ({ index }) {
            return [_c("span", [_vm._v(_vm._s(index + 1))])]
          },
        },
        {
          key: `item.interesses`,
          fn: function ({ item }) {
            return [
              _vm._v(
                " " +
                  _vm._s(
                    item[_vm.interessesAttr].map((a) => a.nome).join(", ")
                  ) +
                  " "
              ),
            ]
          },
        },
        {
          key: `item.isInstrutor`,
          fn: function ({ item }) {
            return [
              _vm._v(
                " " +
                  _vm._s(_vm.getIsInstrutor(item[_vm.isInstrutorAttr])) +
                  " "
              ),
            ]
          },
        },
        {
          key: `item.data-table-expand`,
          fn: function ({ item, expand, isExpanded }) {
            return [
              _c(
                VTooltip,
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              VBtn,
                              _vm._g(
                                {
                                  attrs: {
                                    height: "100%",
                                    text: "",
                                    width: "100%",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return expand(!isExpanded)
                                    },
                                  },
                                },
                                on
                              ),
                              [
                                _c(
                                  VBadge,
                                  {
                                    attrs: { right: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "badge",
                                          fn: function () {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    item[_vm.cursosAttr].length
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      VIcon,
                                      {
                                        attrs: {
                                          color: "grey lighten-0",
                                          large: "",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(_vm.icone) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _c("span", [
                    _vm._v("Clique para exibir os cursos cadastrados"),
                  ]),
                ]
              ),
            ]
          },
        },
        {
          key: "expanded-item",
          fn: function ({ headers, item }) {
            return [
              _c(
                "td",
                {
                  staticClass: "justify-center",
                  attrs: { colspan: headers.length },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        [
                          _c(
                            VRow,
                            { staticClass: "justify-center" },
                            [
                              _c("app-title", {
                                attrs: { texto: "CURSOS CADASTRADOS" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(VSpacer),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VSimpleTable, {
                            staticClass: "elevation-0 mb-4",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v(" NOME DO CURSO ")]),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          item[_vm.cursosAttr],
                                          function (curso) {
                                            return _c("tr", { key: curso.id }, [
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-row ma-1",
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(curso.nome)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(VSpacer),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }